// NOTE: When adding a provider here, also do the same on server/constants.js
export enum ProductReviewsProviders {
  yotpo = 'yotpo',
  okendo = 'okendo',
  junip = 'junip',
  judgeme = 'reviews',
}

type ProviderBuild = (metafields: any) => Reviews;

type IProvidersFactory = {
  [key in ProductReviewsProviders]?: ProviderBuild;
};

interface ReviewDataYotpo {
  reviews_average: string;
  reviews_count: string;
}

interface ReviewDataOkendo {
  summaryData: {
    reviewAverageValue: string;
    reviewCount: string;
  };
}

interface ReviewDataJunip {
  rating_average: string;
  rating_count: string;
}

interface ReviewDataJudgeme {
  rating: {
    value: string;
  };
  rating_count: string;
}

const ProvidersFactory: IProvidersFactory = {
  [ProductReviewsProviders.yotpo]: (metafields: ReviewDataYotpo) => {
    const { reviews_average, reviews_count } = metafields || {};

    return {
      average: reviews_average,
      count: reviews_count,
    };
  },

  [ProductReviewsProviders.okendo]: (metafields: ReviewDataOkendo) => {
    const { reviewAverageValue, reviewCount } = metafields?.summaryData || {};

    return {
      average: reviewAverageValue,
      count: reviewCount,
    };
  },

  [ProductReviewsProviders.junip]: (metafields: ReviewDataJunip) => {
    const { rating_average, rating_count } = metafields || {};

    return {
      average: rating_average,
      count: rating_count,
    };
  },

  [ProductReviewsProviders.judgeme]: (metafields: ReviewDataJudgeme) => {
    const { rating, rating_count } = metafields || {};

    return {
      average: rating?.value,
      count: rating_count,
    };
  },
};

const getReviewsFromProvider = (
  reviewsProvider: ProductReviewsProviders,
  metafields: Metafields,
): Reviews => {
  return ProvidersFactory[reviewsProvider]?.(metafields[reviewsProvider]) || {};
};

export const getReviewsFromShopProvider = (
  metafields?: Metafields,
): Reviews => {
  if (!metafields) return {};

  const reviewsProvider = getReviewProviderKey(metafields);

  if (!reviewsProvider) return {};

  return getReviewsFromProvider(
    ProductReviewsProviders[reviewsProvider],
    metafields,
  );
};

function getReviewProviderKey(
  metafields: Record<string, unknown>,
): keyof typeof ProductReviewsProviders | null {
  const metafieldKeys = Object.keys(metafields);
  const providerEntry = Object.entries(ProductReviewsProviders).find(
    ([_, value]) => metafieldKeys.includes(value),
  );

  return providerEntry
    ? (providerEntry[0] as keyof typeof ProductReviewsProviders)
    : null;
}
